import { timeFormat } from 'd3-time-format';

export const formatDate = timeFormat('%b %d, %Y');

export const formatDateTime = (date: Date): string => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  const parts = formatter.formatToParts(date);
  const part = (type: string) => parts.find(p => p.type === type)?.value;
  const day = `${part('month')} ${part('day')}, ${part('year')}`;
  const time = `${part('hour')}:${part('minute')}${part('dayPeriod')?.toLowerCase()} ET`;
  return `${day} at ${time}`;
};

export const formatTimeDisplay = (date: Date): string => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  const parts = formatter.formatToParts(date);
  const part = (type: string) => parts.find(p => p.type === type)?.value;
  const timeDisplay = `${part('hour')}:${part('minute')}${part('dayPeriod')?.toLowerCase()} ET`;

  return timeDisplay;
};

type IsSameDateType = {
  date: Date;
  nextDate: Date;
};

export const isSameDate = ({ date, nextDate }: IsSameDateType) => {
  return (
    date.getUTCFullYear() === nextDate.getUTCFullYear() &&
    date.getUTCMonth() === nextDate.getUTCMonth() &&
    date.getUTCDate() === nextDate.getUTCDate()
  );
};
